import { useState } from "react";
import { Outlet } from "react-router";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";

function todayIso() {
  const now = new Date();
  const yyyy = now.getFullYear();
  const mm = String(now.getMonth() + 1).padStart(2, "0");
  const dd = String(now.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}

export function AppShell() {
  const [date, setDate] = useState<string>(todayIso());
  return (
    <div className="flex h-screen w-screen overflow-hidden bg-brand-beige">
      <Sidebar />
      <div className="flex flex-1 flex-col overflow-hidden">
        <Topbar date={date} onDateChange={setDate} />
        <main className="flex-1 overflow-y-auto p-8">
          <Outlet context={{ date }} />
        </main>
      </div>
    </div>
  );
}
